import { useContext, useState } from 'react'

import { Grid } from '@material-ui/core'
import { EditContext } from 'Components/Hooks/ContextEdit'
import ListhWithIcon from 'Components/UI/Molecules/Lists/ListWithIcon'
import Papers from 'Components/UI/Molecules/Papers/PaperList'
import Checklist from 'Components/UI/Organisms/Settings/Users/UsersDialog/Content/Permissions/Checklist'

const Permissions = (props) => {
  const { data, setData } = props
  const [id, setId] = useState(0)

  const handleListItemClick = (id) => {
    setId(id.id)
  }
  const [edit] = useContext(EditContext)

  const handleToggle = (permissionId, currentStatus, descripcion) => {
    const newAuth = [...data.data.auth.auth]

    const updatedAuth = newAuth.map((item) => {
      if (item.id === permissionId) {
        return { ...item, autorizacion: currentStatus === 1 ? 0 : 1 }
      }

      if (descripcion === 'Interfaz de gestoría' && item.descripcion === 'Interfaz de ingeniero') {
        return { ...item, autorizacion: 0 }
      }

      if (descripcion === 'Interfaz de ingeniero' && item.descripcion === 'Interfaz de gestoría') {
        return { ...item, autorizacion: 0 }
      }

      if (
        descripcion === 'Edición parcial de clientes' &&
        item.descripcion === 'Edición de un cliente'
      ) {
        return { ...item, autorizacion: 0 }
      }

      if (
        descripcion === 'Edición de un cliente' &&
        item.descripcion === 'Edición parcial de clientes'
      ) {
        return { ...item, autorizacion: 0 }
      }

      return item
    })

    setData({
      ...data,
      data: {
        ...data.data,
        auth: {
          ...data.data.auth,
          auth: updatedAuth,
        },
      },
    })
  }

  function filtered(data) {
    if (data) {
      return data
        .filter((e) => e.navbar_id === id)
        .sort((a, b) => a.descripcion.localeCompare(b.descripcion))
    } else {
      return []
    }
  }

  return (
    <Grid
      container
      justifyContent="center"
      style={{
        display: 'flex',
        justifyContent: 'space-evenly',
        overflowY: 'scroll',
        height: '45rem',
        paddingBottom: '15rem',
      }}
    >
      <Grid item sm={4} xs={12} style={{ overflowY: 'scroll' }}>
        <Papers
          styles={{ maxHeight: '43rem' }}
          height="40rem"
          children={
            <ListhWithIcon
              data={[...data.data.auth.navegation].sort((a, b) =>
                a.descripcion.localeCompare(b.descripcion)
              )}
              nameIncludes="descripcion"
              onClickSelect={handleListItemClick}
              selectedItem={id}
              style={{ fontSize: '14px' }}
            />
          }
        />
      </Grid>
      <Grid item sm={6} xs={12}>
        <Papers
          styles={{ maxHeight: '43rem' }}
          height="40rem"
          children={
            <Checklist
              filteredData={filtered(data.data.auth.auth)}
              onToggle={(id, autorizacion, descripcion) =>
                handleToggle(id, autorizacion, descripcion)
              }
              data={data}
              id={id}
              edit={edit}
            />
          }
        />
      </Grid>
    </Grid>
  )
}

export default Permissions
